/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { SaveDealAsDraft200ResponseCardTransactionEvidenceListInner } from './save-deal-as-draft200-response-card-transaction-evidence-list-inner';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealAsDraft200ResponseIntegratedBy } from './save-deal-as-draft200-response-integrated-by';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealAsDraft200ResponseInvoiceIssuer } from './save-deal-as-draft200-response-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealAsDraft200ResponseJournalEntriesInner } from './save-deal-as-draft200-response-journal-entries-inner';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealAsDraft200ResponseJournalizedBy } from './save-deal-as-draft200-response-journalized-by';

/**
 * 
 * @export
 * @interface SaveDealAsDraft200Response
 */
export interface SaveDealAsDraft200Response {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'freeeDealId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsDraft200Response
     */
    'partnerId': number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsDraft200Response
     */
    'amountYen': number;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'visaTransactionReferenceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'status': SaveDealAsDraft200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'cardHolder': string | null;
    /**
     * 
     * @type {SaveDealAsDraft200ResponseJournalizedBy}
     * @memberof SaveDealAsDraft200Response
     */
    'journalizedBy': SaveDealAsDraft200ResponseJournalizedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'journalizedAt': string | null;
    /**
     * 
     * @type {SaveDealAsDraft200ResponseIntegratedBy}
     * @memberof SaveDealAsDraft200Response
     */
    'integratedBy': SaveDealAsDraft200ResponseIntegratedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'integratedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'userAccountName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'userAccountGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'userAccountGroupName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsDraft200Response
     */
    'isOnDemand': boolean | null;
    /**
     * 
     * @type {Array<SaveDealAsDraft200ResponseJournalEntriesInner>}
     * @memberof SaveDealAsDraft200Response
     */
    'journalEntries': Array<SaveDealAsDraft200ResponseJournalEntriesInner>;
    /**
     * 
     * @type {Array<SaveDealAsDraft200ResponseCardTransactionEvidenceListInner>}
     * @memberof SaveDealAsDraft200Response
     */
    'cardTransactionEvidenceList': Array<SaveDealAsDraft200ResponseCardTransactionEvidenceListInner>;
    /**
     * true if the deal has one or more evidences and those all are not qualified, which should be shown as a warning to users.
     * @type {boolean}
     * @memberof SaveDealAsDraft200Response
     */
    'isAllEvidencesNotQualified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsDraft200Response
     */
    'canSync': boolean;
    /**
     * 
     * @type {SaveDealAsDraft200ResponseInvoiceIssuer}
     * @memberof SaveDealAsDraft200Response
     */
    'invoiceIssuer': SaveDealAsDraft200ResponseInvoiceIssuer | null;
}

export const SaveDealAsDraft200ResponseStatusEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type SaveDealAsDraft200ResponseStatusEnum = typeof SaveDealAsDraft200ResponseStatusEnum[keyof typeof SaveDealAsDraft200ResponseStatusEnum];


